// extracted by mini-css-extract-plugin
export var col = "WordScramble-module--col--ba59n";
export var colLeft = "WordScramble-module--col-left--ITXZe";
export var colRight = "WordScramble-module--col-right--JhMaf";
export var grid = "WordScramble-module--grid--rYHOO";
export var headline = "WordScramble-module--headline--h82MN";
export var wrapper = "WordScramble-module--wrapper--+uAgi";